import Vue from 'vue';
import entrepreneurCashWithdrawal from './entrepreneur-cash-withdrawal/entrepreneur-cash-withdrawal.vue';
Vue.component('entrepreneur-cash-withdrawal', entrepreneurCashWithdrawal);
